import { inject, Injectable } from '@angular/core';
import { Router, type ActivatedRouteSnapshot, type CanActivate, type RouterStateSnapshot, type GuardResult } from '@angular/router';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { UserRepository } from '../state/user.repository';

@Injectable({ providedIn: 'any' })
export class UserAuthenticatedGuard implements CanActivate {
    private readonly router = inject(Router);
    private readonly userRepository = inject(UserRepository);
    private readonly environmentService = inject(EnvironmentService);
    private readonly myBigRedirectionPath = `${this.environmentService.privatePath}/login?destination=`;

    // eslint-disable-next-line sonarjs/function-return-type
    public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult {
        if (this.userRepository.getToken() !== undefined) {
            return true;
        }

        // provide support for redirection to non guarded URIs
        try {
            const decodedUri = decodeURIComponent(state.url);
            if (decodedUri.includes(this.myBigRedirectionPath)) {
                state.url = decodedUri.slice(this.myBigRedirectionPath.length);
            }

            // We need to remove logout to prevend an endless loop
            return this.router.parseUrl(`${this.myBigRedirectionPath}${encodeURIComponent(state.url.replace('logout', ''))}`);
        } catch (e: unknown) {
            // eslint-disable-next-line no-console
            console.error(e);

            return false;
        }
    }
}
